import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { consume } from '@lit/context'
import { breakpointContext } from '../../contexts/breakpoint'
import { BREAKPOINT } from '../../util/breakpoints'
import { classMap } from 'lit/directives/class-map.js'

@customElement('rq-continue-button')
export class ContinueButton extends LitElement {
  static styles = css`
    :host {
      display: flex;
      justify-content: flex-end;
      width: fit-content;
    }
    lh-button {
      width: fit-content;
    }
    @media (max-width: 768px) {
      :host {
        display: block;
        justify-content: initial;
        width: 100%;
      }
      lh-button {
        width: 100%;
      }
    }
    .content {
      display: grid;
      grid-template-columns: auto auto auto;
      gap: 4px;
    }
    .icon {
      display: flex;
      justify-content: start;
    }
    .icon-padding {
      padding-top: 1px;
    }
  `

  @property({ type: Boolean })
  disabled: boolean = true

  @property({ type: Boolean })
  submit: boolean = false

  @consume({ context: breakpointContext, subscribe: true })
  breakpoint!: BREAKPOINT

  get isMobile() {
    return (
      this.breakpoint === BREAKPOINT.PHONE ||
      this.breakpoint === BREAKPOINT.TABLET
    )
  }
  // Routing is handled by the parent form/container after quote submission.

  render() {
    return html`<lh-button
      size="lg"
      .disabled=${this.disabled}
      data-testid="submit-button"
      @click=${() => this.dispatchEvent(new Event('click', { bubbles: true }))}
      variant=${'filled'}
      ?full-width=${this.isMobile}
      analytics-id="ancillary-rate-quote:continue-button:button-text"
    >
      <div class="content">
        <div></div>
        <div>Continue</div>
        <div class=${classMap({ icon: true, 'icon-padding': !this.isMobile })}>
          <lh-icon size="md" name="caret-right"> </lh-icon>
        </div>
      </div>
    </lh-button>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rq-continue-button': ContinueButton
  }
}
